import { render } from "./TermsConditionsModal.vue?vue&type=template&id=09599e33"
import script from "./TermsConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsConditionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__